export default __webpack_public_path__ + "static/media/logo.65eb8d19.svg";